module.exports = __webpack_public_path__ + "img/gorila_yes.dbc525b9.png";